import {
  Button,
  Fab,
  Theme as MuiTheme,
  Popover,
  useMediaQuery,
} from '@mui/material';
import { FC, useState } from 'react';
import {
  Filters,
  NavBtn,
  NavigationWrapper,
  OptionsContainer,
  Today,
  Wrapper,
  Zoom,
} from './styles';
import styled, { useTheme } from 'styled-components';

import { Icon } from '../../../../components';
import { Info } from '@mui/icons-material';
import { Theme } from '../../../../styles';
import { TopbarProps } from './types';
import { useCalendar } from '../../../../context/CalendarProvider';
import { useLanguage } from '../../../../context/LocaleProvider';
import { useTranslate } from '../../../../../../locales';

const ColorBox = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 4px;
  margin-right: 4px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ColorText = styled.div`
  margin-top: 1px;
  margin-right: 12px;
`;

const Topbar: FC<TopbarProps> = ({ width }) => {
  const { topbar } = useLanguage();
  const translate = useTranslate();
  const {
    data,
    handleGoNext,
    handleGoPrev,
    handleGoToday,
    zoom,
    onClickNewRequest,
    changeZoom,
  } = useCalendar();
  const { colors } = useTheme() as Theme;
  const isSmall = useMediaQuery((theme: MuiTheme) =>
    theme.breakpoints.down('sm'),
  );

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Wrapper width={width} isSmall={isSmall}>
      <Filters></Filters>
      {isSmall ? null : (
        <Row style={{ fontSize: 12 }}>
          <Row>
            <ColorBox style={{ backgroundColor: '#d0eef0' }} />
            <ColorText>Finished/Aborted</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: '#738ce1' }} />
            <ColorText>Confirmed</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: '#f3cf7c' }} />
            <ColorText>WaitingForUser</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: 'green' }} />
            <ColorText>Running</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: '#fdb990' }} />
            <ColorText>Revoked</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: 'red' }} />
            <ColorText>Late</ColorText>
          </Row>
        </Row>
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}>
        <Row style={{ fontSize: 12, padding: 12, height: 'auto', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Row>
            <ColorBox style={{ backgroundColor: '#d0eef0' }} />
            <ColorText>Finished/Aborted</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: '#738ce1' }} />
            <ColorText>Confirmed</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: '#f3cf7c' }} />
            <ColorText>WaitingForUser</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: 'green' }} />
            <ColorText>Running</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: '#fdb990' }} />
            <ColorText>Revoked</ColorText>
          </Row>
          <Row>
            <ColorBox style={{ backgroundColor: 'red' }} />
            <ColorText>Late</ColorText>
          </Row>
        </Row>
      </Popover>
      <NavigationWrapper isSmall={isSmall}>
        <NavBtn disabled={!data?.length} onClick={handleGoPrev}>
          <Icon iconName="arrowLeft" height="15" fill={colors.textPrimary} />
          {translate('admin.prev')}
        </NavBtn>
        <Today onClick={handleGoToday}>{translate('admin.today')}</Today>
        <NavBtn disabled={!data?.length} onClick={handleGoNext}>
          {translate('admin.next')}
          <Icon iconName="arrowRight" height="15" fill={colors.textPrimary} />
        </NavBtn>
      </NavigationWrapper>
      <OptionsContainer>
        {isSmall ? null : (
          <Button variant="contained" onClick={onClickNewRequest}>
            {translate('admin.newRequest')}
          </Button>
        )}
        <Zoom isSmall={isSmall}>
          <Button
            onClick={() => changeZoom(0)}
            variant={zoom === 0 ? 'contained' : 'outlined'}
            size="small">
            {translate('admin.monthly')}
          </Button>
          <Button
            onClick={() => changeZoom(1)}
            variant={zoom === 1 ? 'contained' : 'outlined'}
            size="small">
            {translate('admin.weekly')}
          </Button>
          <Button
            onClick={() => changeZoom(2)}
            variant={zoom === 2 ? 'contained' : 'outlined'}
            size="small">
            {translate('admin.daily')}
          </Button>

          {isSmall ? (
            <Button variant="outlined" size="small" onClick={handleClick}>
              <Info />
            </Button>
          ) : null}
        </Zoom>
      </OptionsContainer>
    </Wrapper>
  );
};
export default Topbar;
